import { onLCP, onCLS, onTTFB, onINP, type Metric } from 'web-vitals';
import { telemetryService } from '@/services/telemetryService';

function reportMetric(metric: Metric): void {
  telemetryService.trackMetric(
    `perf.web_vitals.${metric.name.toLowerCase()}`,
    metric.value,
    { rating: metric.rating }
  );
}

/** Register all Web Vitals observers. Call once after telemetry is initialized. */
export function reportWebVitals(): void {
  onCLS(reportMetric);
  onINP(reportMetric);
  onLCP(reportMetric);
  onTTFB(reportMetric);
}
